<template>
    <di v-loading="loading" class="PrintCommandes">
        <div>
            <!-- v-print="'#printMe'"-->
            <el-button @click="printTable">{{ langPage['compte-commandes-groupes-details']['TXT_imprimeresume'] }}</el-button>
        </div>
        <div id="printMe">
            <el-table
                v-loading="loading"
                v-for="(commande,indexCommande) of dataAll.commandes"
                :key="indexCommande"
                :data="commande.produits"
                :span-method="objectSpanMethod"
                size="mini"
                style="margin: 20px 0;"
                show-summary
                :summary-method="getSummaries"
                border>
                <el-table-column v-for="(item,index) of tablelist"
                                 :key="index"
                                 :label="item.title"
                                 :prop="item.key"
                                 :formatter="formatterKey"
                                 :width="item.width?item.width:'100'"
                                 min-width="80"
                                 align="center"></el-table-column>
            </el-table>
        </div>
    </di>
</template>

<script>
import base from "../api/base";
import printJS from 'print-js';

let commonUtils = require('@/utils/common_utils');
let moment = require('moment');
let productListHelper = require('@/utils/helper/ProductList/productList_helper');
export default {
    name: "PrintCommandes",//打印订单页面
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            loading: false,
            lang: this.$store.state.lang,
            langPage: this.$store.state.langPage,
            active: 0,
            tabList: [
                this.$store.state.langPage['compte-commandes-liste']['TXT_articles'],
                this.$store.state.langPage['v4-topmenu']['TXT_rupture'],
                this.$store.state.langPage['compte-commandes-details']['TXT_adresse'],
                // this.$store.state.langPage['v4-topmenu']['TXT_moyendepaiement']
            ],
            tablelist: [
                {
                    title: this.$store.state.langPage['compte-commandes-groupes-details']['TXT_grossiste'],
                    key: "vendeur_marque"
                },
                {
                    title: 'id',
                    key: "id_produit"
                },
                {
                    title: this.$store.state.langPage['compte-commandes-groupes-details']['TXT_reference'],
                    key: "reference"
                },
                {
                    title: this.$store.state.langPage['compte-commandes-groupes-details']['TXT_categories'],
                    key: "id_categorie"
                },
                {
                    title: this.$store.state.langPage['compte-commandes-groupes-details']['TXT_description'],
                    key: `produits_description`,
                    width: '250',
                },
                {
                    title: this.$store.state.langPage['compte-commandes-groupes-details']['TXT_provenances'],
                    key: "provenance_libelle"
                },
                {
                    title: this.$store.state.langPage['compte-commandes-groupes-details']['TXT_prixpcs'] + '(€)',
                    key: "prix_ht"
                },
                {
                    title: this.$store.state.langPage['compte-commandes-groupes-details']['TXT_composition'],
                    key: "compositions",
                    width: '150',
                },
                {
                    title: this.$store.state.langPage['compte-commandes-groupes-details']['TXT_poidspcs'] + '(Kg)',
                    key: "poids"
                },
                {
                    title: this.$store.state.langPage['compte-commandes-groupes-details']['TXT_quantite'],
                    key: "pack_qte"
                },
                {
                    title: this.$store.state.langPage['compte-commandes-groupes-details']['TXT_poidstotal'] + '(Kg)',
                    key: "poids_total"
                },
                {
                    title: this.$store.state.langPage['compte-commandes-groupes-details']['TXT_quantitetotal'],
                    key: "per_pack_total_qte"
                },
                {
                    title: this.$store.state.langPage['compte-commandes-groupes-details']['TXT_prixtotal'] + '(€)',
                    key: "prix_ht"
                },
            ],
            carteTitle: [
                {
                    title: this.$store.state.langPage['landingpage']['TXT_formnom'],
                    key: "NomContact",
                },
                {
                    title: this.$store.state.langPage['panier-adresse']['TXT_societe'],
                    key: "Societe",
                },
                {
                    title: this.$store.state.langPage['compte-commandes-details']['TXT_adresse'],
                    key: "adresse",
                },
                {
                    title: this.$store.state.langPage['compte-informations-popup-adresse']['TXT_telephone'],
                    key: "telephone",
                },
                {
                    title: this.$store.state.langPage['compte-informations-popup-adresse']['TXT_mobile'],
                    key: "mobile",
                },
                {
                    title: this.$store.state.langPage['v4-topmenu']['TXT_payname'],
                    key: "pay_name",
                    onlyShow: true
                }
            ],
            msg: [
                {
                    a: "Speed Transport 2000",
                    b: "F492744",
                    x: "ssdsds",
                    Téléphone: "111",
                    Site: "Site internet",
                    Commenaire:
                        "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
                }
            ],
            paiementnTitle2: [
                {
                    key: "a"
                },
                {
                    key: "b"
                },
                {
                    key: "c"
                },
                {
                    key: "d"
                }
            ],
            paiementn: [],
            tabledata: [],
            dataAll: {},
            command_group: {},
            commandes: [],
            stockout_products: [],
            adrLIVRAISON: [],
            adrFACTURATION: [],
        }
    },
    mounted() {
        this.initData();
    },
    methods: {
        initData() {
            this.getCommandesGroup();
        },
        async getCommandesGroup() {
            let para = {
                id_ahceteur: this.$route.query.acheteurId,
                id_commande: this.$route.query.commandeId
            }
            this.loading = true;
            this.$api.info.get_commandes_groupes({
                id_langue: this.$store.state.lang,
                id_commande_groupe: para.id_commande
            }).then((res) => {
                this.loading = false;
                if (res.code === 0) {
                    this.dataAll = res.data;
                    this.command_group = this.dataAll.command_group;
                    this.commandes = this.dataAll.commandes;
                    if (this.dataAll.stockout_products && this.dataAll.stockout_products.length > 0) {
                        this.stockout_products = this.dataAll.stockout_products;
                    }
                    this.stockout_products.forEach(prod => {
                        this.handleProduct(prod);
                    })

                    //收货地址修改
                    this.commandes[0].adrLIVRAISON.pay_name = this.commandes[0].adrLIVRAISON.pay.texte_fr;
                    this.commandes[0].adrFACTURATION.pay_name = this.commandes[0].adrFACTURATION.pay.texte_fr;
                    this.adrLIVRAISON.push(this.commandes[0].adrLIVRAISON);
                    this.adrFACTURATION.push(this.commandes[0].adrFACTURATION);
                    for (let command of this.commandes) {
                        command.id_commande_groupe_name = this.command_group.id_commande_groupe_name;
                        for (let prod of command.produits) {
                            this.handleProduct(prod);
                        }
                    }
                    console.log('dataAll', this.dataAll);
                } else {
                    console.log(res.message);
                }
            })
        },
        objectSpanMethod({row, column, rowIndex, columnIndex}) {
            if (columnIndex === 0) {
                if (rowIndex === 0) {
                    return {
                        rowspan: 2,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        },
        formatterKey(row, column) {
            switch (column.property) {
                case 'id_categorie':
                    // eslint-disable-next-line no-case-declarations
                    let idCategory = row[column.property];
                    return productListHelper.getCategoryName(idCategory, this);
                case 'produits_description':
                    return row.produits_description.texte_fr;
                case 'provenance_libelle':
                    return row.provenance.provenances_langue.libelle;
                case 'compositions':
                    // eslint-disable-next-line no-case-declarations
                    let valueComp = 'produit:';
                    for (let itemComp of row.compositions) {
                        valueComp += `${itemComp.produits_compositions.value}%${itemComp.compositions_langues[0].libelle} `
                    }
                    return valueComp;
                case 'poids_total':
                    return Number(row.poids).mul(row.per_pack_total_qte)
                default:
                    return row[column.property];
            }
        },
        getSummaries(param) {
            const {columns, data} = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = 'Total';
                    return;
                }
                if (![9, 10, 11].includes(index)) return '';
                const values = data.map(item => {
                    if (column.property == 'poids_total') {
                        return Number(item.poids).mul(item.per_pack_total_qte)
                    }
                    return Number(item[column.property])
                });
                if (!values.every(value => isNaN(Number(value)))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return Number(prev).add(curr);
                        } else {
                            return prev;
                        }
                    }, 0);
                    sums[index] += '';
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },
        printTable() {
            const style = '@page { margin: 20px } @media print {  }'//自定义样式
            printJS({
                printable: 'printMe',//要打印内容的id
                type: 'html',
                style: style,
                scanStyles: false
            })
        }
    }
}
</script>

<style lang="less" scoped src="@/assets/viewCss/views/PrintCommandes.less">
</style>
